import PaymentType from "../../entities/PaymentType";

class PaymentTypeResponse {
    public value: number;
    public fromValue: number;
    public toValue: number;
    public paymentType: PaymentType;
    public isPercentage: boolean

    constructor(value: number, paymentType: PaymentType, isPercentage: boolean, fromValue: number, toValue: number) {
        this.paymentType = paymentType;
        this.value = value;
        this.isPercentage = isPercentage;
        this.fromValue = fromValue;
        this.toValue = toValue;
    }

}

export default PaymentTypeResponse;